import { Action, Module, Mutation } from "vuex-module-decorators";
import { CouponTypeEnums } from "@/enums/mall";
import { queryRequest } from "@/utils/request";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { RootState } from "@/store";
import { queryCouponListByUser } from "@/graphql/coupon.gql";
import type { PaginationDataState } from "@/types";

export interface MallMyCouponState extends PaginationDataState {
  tabData: any[];
  listData: any[];
  selectedTab: string[];
}

@Module({ name: "MallMyCouponModule", namespaced: true })
export default class MallMyCouponModule
  extends PaginationModule<MallMyCouponState, RootState>
  implements MallMyCouponState {
  public tabData = [];
  public listData = [];
  public selectedTab = ["1"]; // 默认未使用

  @Mutation
  saveTabsDataMutation(data: any[]) {
    this.tabData = data || [];
  }
  @Mutation
  saveListDataMutation(data: any[]) {
    this.listData = data || [];
  }
  @Mutation
  addListDataMutation(data: any[] = []) {
    this.listData.push(...(data || []));
  }
  @Mutation
  saveSelectedTabMutation(data: any[]) {
    this.selectedTab = data || ["1"]; // 默认未使用
  }

  @Action
  async initListAction() {
    let {
      state: {
        selectedTab,
        paginationData: { pageNum, pageSize }
      }
    } = this.context;
    const {
      dataList = [],
      pageInfo: { totalCount }
    } = await queryRequest({
      query: queryCouponListByUser,
      variables: {
        condition: {
          status: selectedTab.join(",") || CouponTypeEnums.USEABLE, // 默认查询未使用
          opsTypeList: ["201", "202", "203"]
        },
        pageInput: { pageNum, pageSize }
      }
    });
    let {
      commit,
      state: { paginationData }
    } = this.context;

    let allData = dataList.map(item => item.data).filter(Boolean);

    commit(
      paginationData.pageNum === 1
        ? "saveListDataMutation"
        : "addListDataMutation",
      allData
    );
    // 保存总数
    commit("savePaginationData", { ...paginationData, totalCount });
  }
}
